import { Link, useParams } from "react-router-dom"
import AppLayout from "./AppLayout"
import { Button } from "./ui/button"
import { CheckCircle } from "lucide-react"

const CollectionSuccessScreen = () => {
  const { id } = useParams()

  return (
    <AppLayout>
      <div className="flex flex-col items-center justify-center min-h-[80vh] text-center">
        <div className="relative h-[100px] w-[100px] mb-6">
          <img src="/images/pranaam-365-logo.png" alt="Pranaam365 Logo" className="w-full h-full object-contain" />
        </div>

        <div className="rounded-full bg-green-100 p-3 mb-4">
          <CheckCircle className="h-12 w-12 text-green-600" />
        </div>

        <h1 className="text-2xl font-bold mb-2 text-gray-800">Collection Complete!</h1>
        <p className="text-gray-500 mb-8">Sample has been collected successfully and marked as complete.</p>

        <div className="space-y-4 w-full">
          <Button asChild className="w-full bg-pranaam-red hover:bg-red-700 text-white">
            <Link to="/dashboard">Back to Dashboard</Link>
          </Button>

          <Button variant="outline" asChild className="w-full border-gray-200 hover:bg-gray-50 text-gray-800">
            <Link to="/appointments">View All Appointments</Link>
          </Button>
        </div>
      </div>
    </AppLayout>
  )
}

export default CollectionSuccessScreen
